import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import {
  IApplicationExecutor,
  ICity,
  IConclusionAct,
  IEmployee,
  IExecutor,
  IPosition,
  IPropertyInfo,
  IRights,
} from './interfaces';

export const getEmployeeList = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IEmployee[]>('/employee/search', config)
    .then((response) => response.data);
};

export const getExecutorPositions = (realEstateGuid: string, config?: AxiosRequestConfig) => {
  return instance()
    .get<IPosition[]>('/executor/listExecutorPositions/' + realEstateGuid, config)
    .then((response) => response.data);
};

export const getExecutorParentPositions = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IPosition[]>('/executor/listParentPositions', config)
    .then((response) => response.data);
};

export const getExecutorsByPosition = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IExecutor[]>('/executor/listExecutorsByPosition', config)
    .then((response) => response.data);
};

export const getApplicationExecutor = (applicationNumber: string) => {
  return instance()
    .post<IApplicationExecutor>('/application/getApplicationExecutor', { applicationNumber })
    .then((response) => response.data);
};

export const getCities = () => {
  return instance()
    .post<ICity[]>('/city/list')
    .then((response) => response.data);
};

export const createConclusionAct = (values: IConclusionAct) => {
  return instance()
    .post('/conclusionAct/create', values)
    .then((response) => response.data);
};

export const updateConclusionAct = (values: IConclusionAct) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/update', values)
    .then((response) => response.data);
};

export const getUserRights = (applicationNumber: string) => {
  return instance()
    .post<IRights>('/conclusionAct/defineUserRights', { applicationNumber })
    .then((response) => response.data);
};

export const loadConclusionAct = (applicationNumber: string) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/load', { applicationNumber })
    .then((response) => response.data);
};

export const sendConclusionActToSigning = (applicationNumber: string, signature: string) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/sendForSigning', { applicationNumber, signature })
    .then((response) => response.data);
};

export const revokeConclusionAct = (applicationNumber: string) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/revoke', { applicationNumber })
    .then((response) => response.data);
};

export const rejectConclusionAct = (applicationNumber: string, comment: string) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/reject', { applicationNumber, comment })
    .then((response) => response.data);
};

export const getDocument = (applicationNumber: string) => {
  return instance()
    .post('/conclusionAct/generatePdf', { applicationNumber }, { responseType: 'blob' })
    .then((response) => response.data);
};

export const signConclusionAct = (applicationNumber: string, signature: string) => {
  return instance()
    .post<IConclusionAct>('/conclusionAct/sign', { applicationNumber, signature })
    .then((response) => response.data);
};

export const getPropertyInfo = (applicationNumber: string) => {
  return instance()
    .post<IPropertyInfo>('/conclusionAct/loadPropertyInfo', { applicationNumber })
    .then((response) => response.data);
};

export const getUsers = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IExecutor[]>('/users/listPerformance', { search: config?.params.search }, config)
    .then((response) => response.data);
};
